define([
    'text!./templates/basler-side-by-side-offerings.html',
], (BaslerSideBySideOfferingsTemplate) =>{

    const directive = function ($window, $compile, $filter, ModalService, MFPCoverageService, TextRetrievalService, ContextService) { // NOSONAR
        return {
            restrict: 'EA',
            scope: {
                offeringViews: '=',
                coverageStructure: '=',
                getCoverageFromOfferingCallback: '&getCoverageFromOffering',
                compareOfferings: '&',
                onBuyOffering: '&',
                onResetOfferingCustomization: '&',
                selectedOffering: '=',
                previous: '&',
                onSelectedOfferingChanged: '&',
            },
            template: BaslerSideBySideOfferingsTemplate,
            transclude: true,
            link: linkFunction,
        };

        function linkFunction(scope, element, attrs, ctrl, transclude) { // NOSONAR

            scope.selectOffering = function (offering) {
                scope.selectedOffering = offering;
                scope.onSelectedOfferingChanged({offering: offering});
            };

            scope.getSelectedStyle = function (offering) {
                return isSelectedOffering(offering) ? 'side-by-side-offering-selected-cell' : '';
            };

            scope.buyOffering = function (offering) {
                return scope.onBuyOffering({offering: offering});
            };

            scope.resetOfferingCustomization = function (offering) {
                scope.onResetOfferingCustomization({offering: offering});
            };

            scope.slogans = {};

            scope.getSlogan = offeringShortName => TextRetrievalService.getSlogan(`offer_${offeringShortName}`)
                .then((slogan) => { scope.slogans[offeringShortName] = slogan; });

            scope.getCoverageFromOffering = getCoverageFromOffering;
            scope.isOfferCustomized = isOfferCustomized;
            scope.offeringSort = offeringSort;
            scope.hasPromotion = hasPromotion;
            scope.getPromotionData = getPromotionData;
            scope.getPromotionSum = getPromotionSum;
            scope.isMonthlyNeeded = () => ContextService.isPartnerLeasingProduct();
            scope.getBottomTranslationKey = getBottomTranslationKey;
            bindData();

            function bindData() {
                scope.$watch('tableData', buildTableBodies);
                scope.$watch('offeringViews', () =>{
                    scope.tableData = createTableData(scope.offeringViews, scope.coverageStructure);
                });
                scope.$watch('coverageCodes', () =>{
                    scope.tableData = createTableData(scope.offeringViews, scope.coverageStructure);
                });
                scope.tableData = createTableData(scope.offeringViews, scope.coverageStructure);
            }

            function getPromotionData(offering) {
                return MFPCoverageService.getGroupedPromotionsForDisplay(offering.lobs.mFPLine.value);
            }

            function getBottomTranslationKey(promotionData) {
                if (hasPromotion(promotionData)) {
                   return 'quoteandbind.views.mfp-confirmation.offer.premium-all-included-promotion';
                }
                return 'quoteandbind.views.mfp-confirmation.offer.premiums-all-included';
            }

            function hasPromotion(promotionData) {
                return MFPCoverageService.hasPromotionsInAnyGroup(promotionData);
            }

            function getPromotionSum(promotionData) {
                return MFPCoverageService.getPromotionSumFromGroupedPromotions(promotionData);
            }

            function isOfferCustomized(offeringView) {
                return (offeringView && offeringView.isCustomized && offeringView.isCustomized.value);
            }

            function isEditable() {
                return !(ContextService.getChannel() === 'santander' && ContextService.isPartnerLeasingProduct())
            }

            function isSelectedOffering(offering) {
                if (!offering || !scope.selectedOffering) {
                    return false;
                }
                return scope.compareOfferings({
                    offering1: offering,
                    offering2: scope.selectedOffering,
                });
            }

            function displayCoverageHelpText(patternCode) {
                return patternCode === 'MFPLiabilityCov' //NOSONAR
                    || patternCode === 'MFPCollisionCascoCov' //NOSONAR
                    || patternCode === 'MFPPartialComprehensiveCov' //NOSONAR
                    || patternCode === 'MFPSupplementaryCoverCov' //NOSONAR
                    || patternCode === 'MFPAccidentCov'; //NOSONAR
            }

            function getCoverageFromOffering(offering, coverageCode, group) {
                return scope.getCoverageFromOfferingCallback({
                    offering: offering,
                    coverageCode: coverageCode,
                    group: group,
                });
            }

            /**
             * creates <tbody>s for all groups by prepending before <tfoot>
             */
            function buildTableBodies() {
                element.find('tbody').remove();
                const tfoot = element.find('tfoot');
                const showHeaderRow = scope.tableData.length > 1;
                scope.tableData.forEach((group) =>{
                    const tbody = buildTableBody(group, showHeaderRow);
                    tfoot.before(tbody);
                });
            }

            /**
             * Creates one <tbody> that contains coverage and offering data for one group
             * @param group
             * @returns {Object}
             */
            function buildTableBody(group, showHeaderRow) {
                const tbody = angular.element('<tbody></tbody>');
                if (showHeaderRow) {
                    const tr = angular.element('<tr class="group-title-row"></tr>');

                    // Diego Cabero, sorting elements by priority before using it
                    group.tableRowsData.sort((a, b) => a[0].coverage.value.priority - b[0].coverage.value.priority);

                    group.tableRowsData[0].forEach((tableCellData) =>{
                        const groupTitle = group.title.replace('mFPLine', $filter('translate')('quoteandbind.views.mfp-summary.allvehicles'));
                        const td = angular.element(`<td class="group-title" ng-click="selectOffering(tableCellData.offering)" ng-class="getSelectedStyle(tableCellData.offering)">${groupTitle}</td>`);
                        const tdScope = scope.$new();
                        tdScope.tableCellData = tableCellData;
                        tr.append($compile(angular.element(td))(tdScope));
                    });
                    tbody.append(tr);
                }
                group.tableRowsData.forEach((tableRowData) =>{
                    const tr = angular.element('<tr class="group-content-row"></tr>');
                    tableRowData.forEach((tableCellData) =>{
                        const td = buildTableCell(tableCellData);
                        doTransclude(td, group.title, tableCellData);
                        tr.append(td);
                    });
                    tbody.append(tr);
                });
                return tbody;
            }

            function buildTableCell(tableCellData) {
                const template = '<td ng-click="selectOffering(tableCellData.offering)"' +
                    ' ng-class="getSelectedStyle(tableCellData.offering)"' +
                    '></td>';
                const tdScope = scope.$new();
                tdScope.tableCellData = tableCellData;
                const tdElement = $compile(angular.element(template))(tdScope);
                return tdElement;
            }

            /**
             * Appends transcluded content to the given element. Injects the offeringView, coverageView
             * and isSelected() function into the transclusion scope so consumers can use them. Yay!
             * @param tdElement
             * @param group
             * @param tableCellData
             */
            function doTransclude(tdElement, group, tableCellData) {
                transclude((transcludeElement, transcludeScope) =>{
                    transcludeScope.offeringView = tableCellData.offering;
                    transcludeScope.coverageView = tableCellData.coverage;
                    transcludeScope.isSelectedOffering = function () {
                        return isSelectedOffering(tableCellData.offering);
                    };
                    transcludeScope.displayCoverageHelpText = function (patternCode) {
                        return displayCoverageHelpText(patternCode);
                    };
                    transcludeScope.isEditable = function() {
                        return isEditable();
                    };
                    transcludeScope.tableGroup = group;
                    tdElement.append(transcludeElement);
                });
            }

            /**
             * Returns table data like this:
             * [
             *  { // table group (corresponds to <tbody>)
             *      title: 'mFPLine',
             *      tableRowsData: [
             *          [{offering1, coverage1}, {offering2, coverage1}, {offering3, coverage1}], // table row (<tr>)
             *          [{offering1, coverage2}, {offering2, coverage2}, {offering3, coverage2}],
             *          [{offering1, coverage3}, {offering2, coverage3}, {offering3, coverage3}]
             *      ]
             *  },
             *  ...
             * ]
             */
            function createTableData(offerings, coverageStructure) {
                return coverageStructure.map(coverage => ({
                    title: coverage.title,
                    tableRowsData: coverage.coverageCodes.map(coverageCode => getTableRowData(coverageCode, offerings, coverage.title)),
                }));
            }

            function offeringSort(tableCell) {
                switch (tableCell.offering.offeringShortName.value) {
                    case 'S':
                        return 1;
                    case 'M':
                        return 2;
                    case 'L':
                        return 3;
                    default:
                        return 0;
                }
            }

            function getTableRowData(coverageCode, offerings, group) {
                return offerings.sort((offering1, offering2) => (
                    offeringSort({offering: offering1}) - offeringSort({offering: offering2})
                )).map(offering => ({
                    offering: offering,
                    coverage: getCoverageFromOffering(offering, coverageCode, group),
                }));
            }

        }
    };
    directive.$inject = ['$window', '$compile', '$filter', 'ModalService', 'MFPCoverageService', 'TextRetrievalService', 'ContextService'];
    return directive;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerSideBySideOfferings.js